import React from 'react';

import { SearchForm } from '../../../helpers/uiComponents/Search';
import { ResultList } from '../../../helpers/uiComponents/ResultList';

import NewBlogForm from './NewBlogForm';
import BlogFilters from './BlogFilters';

class BlogExplorer extends React.Component {
    render() {
        const blogs = this.props.blogs;
        const load = this.props.load;

        return(
            <div className="column left-column" id="blogs-column">
                <NewBlogForm />
                <section className="section">
                    <h3>All Blogs: {(blogs.length > 0) ? (blogs.length) : ("loading...")}</h3>
                    <SearchForm page="blogs" />
                </section>
                <BlogFilters />
                <div className="list-label">BLOG TITLE <span className="uptime-label">Published</span></div>
                <ResultList
                    page={"blogs"}
                    data={blogs}
                    load={load}
                />

            </div>
        )
    }
}
export default BlogExplorer;


// WEBPACK FOOTER //
// ./src/component_blog/components/BlogExplorer/Explorer.js